export default __webpack_public_path__ + "static/media/gmx-logo-final.b8aed303.png";